import { FilePickerDirection, TableColumn } from '@/components';

export enum KaseFileScreens {
  KaseFileList = 'KaseFilesList',
  KaseFileAdd = 'KaseFileAdd',
  KaseFileEdit = 'KaseFileEdit',
}

export const KaseFileNextRoutes = ['naratives', 'property'];

export const KaseFileDefaultValues = {
  files: [],
};

export const kaseFilesListTableColumns: (TableColumn & { sortKey?: string })[] =
  [
    { key: 'fileName', label: 'File name', sortKey: 'name' },
    { key: 'description', label: 'Description', sortKey: 'description' },
    { key: 'dateUploaded', label: 'Date uploaded', sortKey: 'createdAt' },
    { key: 'uploadedBy', label: 'Uploaded by', sortKey: 'uploadedBy' },
    { key: 'fileType', label: 'File type', sortKey: 'type' },
    { key: 'origin', label: 'Origin', sortKey: 'origin' },
    { key: 'action', label: '' },
  ];

export const fileTypeExtensions: { [key: string]: string[] } = {
  documents: [
    '.pdf',
    '.docx',
    '.doc',
    '.rtf',
    '.txt',
    '.xlsx',
    '.xls',
    '.odt',
    '.csv',
  ],
  photos: ['.jpg', '.jpeg', '.png'],
  videos: ['.mp4', '.mkv', '.mov', '.avi', '.wmv', '.mpg', '.mpeg'],
  audio: ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.wma', '.flac'],
};

export const FileAcceptedTypes = {
  'image/jpeg': [],
  'image/png': [],
  'video/mp4': [],
  'video/mkv': [],
  'video/webm': [],
  'video/ogg': [],
  'video/mov': [],
  'video/mpg': [],
  'video/mpeg': [],
  'audio/mpeg': [], // .mp3
  'audio/mp3': [], // .mp3 (alternative)
  'audio/wav': [], // .wav
  'audio/x-wav': [], // .wav (alternative)
  'audio/ogg': [], // .ogg
  'audio/mp4': [], // .m4a
  'audio/x-m4a': [], // .m4a (alternative)
  'audio/aac': [], // .aac
  'audio/x-ms-wma': [], // .wma
  'audio/flac': [], // .flac
  'application/msword': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // .docx
  'text/csv': [],
  'application/pdf': [],
  'application/rtf': [],
  'text/plain': [],
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [], // .xlsx
  'application/vnd.oasis.opendocument.text': [], // .odt
};

export const filterMenuFormFields = [
  {
    name: 'fileType',
    type: 'autocomplete',
    label: '',
    items: [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Documents',
        value: 'documents',
      },
      {
        label: 'Photos',
        value: 'photos',
      },
      {
        label: 'Videos',
        value: 'videos',
      },
      {
        label: 'Audio',
        value: 'audio',
      },
    ],
  },
];

export const KaseFileFormFields = [
  {
    key: 'photos',
    title: 'Photos',
    items: [
      {
        name: 'files',
        type: 'file',
        label: '',
        enableEditDescription: true,
        direction: 'vertical' as FilePickerDirection,
        grid: {
          md: 12,
          lg: 12,
        },
      },
    ],
  },
];
